import flow from 'lodash/flow';
import { updateisOtherTouched, updateOtherValue } from '../shared/reducer';
import { validate } from '../validators';
import { getServerValidationErrors, mapPropsToValidators } from '../validators';
import { addOther, compareCurrentSum, required } from './validators';
import { commonQuestionState, updateWhy } from '../response/reducer';
import prefill from '../prefillAnswers';

const updateValue = action => state => ({
  ...state,
  rows: state.rows.map(
    (row, rowIndex) =>
      rowIndex === action.rowIndex
        ? {
            ...row,
            isTouched: true,
            value: action.value,
          }
        : row
  ),
});

const updateCurrentSum = state => ({
  ...state,
  currentSum: state.rows.reduce(
    (currentSum, row) => +row.value + currentSum,
    0
  ),
});

const updateNone = action => state => ({
  ...state,
  none: action.checked,
});

const touchAllRows = state => ({
  ...state,
  rows: state.rows.map(row => ({
    ...row,
    isTouched: true,
  })),
});

// initial value fns

const addOtherState = props => state => ({
  ...state,
  isOtherValid: true,
  otherValue: props.otherValue || '',
});

const addConstantSumState = props => state => ({
  ...state,
  currentSum: 0,
  fieldValids: props.rows.map(() => true),
  none: false,
  rows: props.rows.map(row => ({
    name: row.name,
    isTouched: false,
    other: !!row.other,
    value: prefill(props.tmap, row.name, 0),
  })),
  sum: props.sum,
  validators: mapPropsToValidators(
    {
      add_other: props.add_other,
      required: props.required,
    },
    {
      add_other: addOther,
      required: required,
    }
  ).concat([compareCurrentSum]),
});

const reducer = props => (state, action) => {
  if (state === undefined) {
    return flow(
      commonQuestionState(props),
      getServerValidationErrors(props),
      addOtherState(props),
      addConstantSumState(props),
      updateCurrentSum
    )({});
  }

  switch (action.type) {
    case 'CONSTANT_SUM_CHANGE':
      return flow(updateValue(action), updateCurrentSum, validate(action))(
        state
      );

    case 'OTHER_CHANGE':
      return flow(updateOtherValue(action), validate(action))(state);

    case 'OTHER_BLUR':
      return flow(updateisOtherTouched, validate(action))(state);

    case 'CONSTANT_SUM_NONE':
      return flow(updateNone(action), validate(action))(state);

    case 'WHY_CHANGE':
      return flow(updateWhy(action), validate(action))(state);

    case 'SUBMIT':
      return flow(touchAllRows, updateisOtherTouched, validate(action))(state);

    default:
      return state;
  }
};

export default reducer;
